import React from 'react';
import { RegionName } from './components/regions-menu/regions-menu';

interface IRegionsContextProps {
  regions: RegionName[];
  setRegions: (salesOrgs: string[], setByAuth?: boolean) => void;
}

// tslint:disable-next-line:no-empty
const noop = () => {};
export const RegionsContext = React.createContext<IRegionsContextProps>({
  regions: [],
  setRegions: noop,
});
